import React, { Component } from 'react';
import { Input, Form, Row, Col, Modal, message, Select, Button, AutoComplete, DatePicker, Upload, Icon } from 'antd';
import { Message } from 'semantic-ui-react'
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import moment from 'moment';


const FormItem = Form.Item;
const TextArea = Input.TextArea;

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};


class AddOrEditGeneralAgreementModalDialog extends Component {

    refreshBtnOnClicked = () => {
        const {
            id,
            title,
            personInCharge,
        } = this.props.generalAgreementQueryFields;
        this.props.loadGeneralAgreementInfo({id, title, personInCharge});
    }


    componentDidUpdate() {
        const {
            submitSaveGeneralAgreementActionStatus,
        } = this.props;
        const {
            mode,
        } = this.props.addOrEditGeneralAgreementModal;

        if(submitSaveGeneralAgreementActionStatus === ACTION_STATUS.SUCCESS) {
            const msg = this.getActionFromMode(mode) + ' General Agreement succeeded.';
            message.success(msg);
            this.props.initSubmitSaveGeneralAgreementModalActionStatus();
            this.props.resetSubmitSaveGeneralAgreementModal();
            this.refreshBtnOnClicked();
        }
        if(submitSaveGeneralAgreementActionStatus === ACTION_STATUS.ERROR) {
            this.props.initSubmitSaveGeneralAgreementModalActionStatus();
        }
    }


    getActionFromMode(mode) {
        if(mode === 'ADD') {
            return 'Add';
        } else if(mode === 'COPY') {
            return 'Copy';
        } else {
            return 'Edit';
        }
    }


    generalAgreeementHandleChange = (info) => {
        let fileList = [...info.fileList];
        if(!fileList || fileList.length === 0) {
            this.onInputChange({name: 'agreementUploadFileList', value: []});
            this.onInputChange({name: 'uploadRealName', value: undefined});
            this.onInputChange({name: 'uploadOriName', value: undefined});
            return;
        }

        fileList = fileList.slice(-1);
        this.onInputChange({name: 'agreementUploadFileList', value: fileList});
        const file = fileList[0];
        if (!!file && !!file.response) {
          const filename = file.response.data.fileNameWithTimeStamp;
          const originalFileName = file.response.data.originalFileName;
          this.onInputChange({name: 'uploadRealName', value: filename});
          this.onInputChange({name: 'uploadOriName', value: originalFileName});
        }
    }


    onInputChange = ({name, value}) => {
        this.props.addOrEditGeneralAgreemenChangeInput({name, value});
    }
    onPICInputChange = (val) => {
        const value = !val ? undefined : val.join(';');
        this.props.addOrEditGeneralAgreemenChangeInput({name: 'personInCharge', value});
    }


    submitSaveGeneralAgreementModal = () => {
        const {
            mode,
        } = this.props.addOrEditGeneralAgreementModal;
        const {
            id,
            status,
            title,
            department,
            personInCharge,
            company,
            counterparty,
            agreementType,
            executionDate,
            expiryDate,
            noticePeriod,
            terms,
            uploadOriName,
            uploadRealName,
            amount,
            amountCCY,
            payer,
            remarks,
            comments,
            source,
        } = this.props.addOrEditGeneralAgreementModal.fields;

        // 通过Admin端提交，如果是ADD、COPY，后续直接SUBMIT、APPROVE
        let modes = mode;
        if(modes === 'ADD' || modes === 'COPY') {
            modes += ',SUBMIT,APPROVE';
        }

        this.props.form.validateFields((err) => {
            if(err) {
                return;
            }
            // 在addOrEdit页面添加附件后又删除，Form控件会检查不出来，要单独检查
            if(!uploadOriName || !uploadRealName) {
                message.error('Upload of Agreement attachemet is required');
                return;
            }

            this.props.submitSaveGeneralAgreementModal(mode, {
                id,
                status,
                title,
                department,
                personInCharge,
                company,
                counterparty,
                agreementType,
                executionDate,
                expiryDate,
                noticePeriod,
                terms,
                uploadOriName,
                uploadRealName,
                amount,
                amountCCY,
                payer,
                remarks,
                comments,
                source,
                modes,
            });
        });
    }


    render() {
        const { getFieldDecorator } = this.props.form;

        const {
            departmentOptions,
            companyOptions,
            agreementTypeOptions,
            userAccountOptions,
            ccyOptions,
            generalAgreementUploadUrl,
            addOrEditGeneralAgreementModal,
            submitSaveGeneralAgreementActionStatus,
        } = this.props;

        const {
            isOpened,
            mode,
            respErrMsg,
        } = addOrEditGeneralAgreementModal;

        const {
            id,
            status,
            title,
            department,
            personInCharge,
            company,
            counterparty,
            agreementType,
            executionDate,
            expiryDate,
            noticePeriod,
            terms,
            uploadOriName,
            uploadRealName,
            amount,
            amountCCY,
            payer,
            remarks,
            comments,
            agreementUploadFileList,
        } = addOrEditGeneralAgreementModal.fields;

        const personInChargeArray = !personInCharge ? [] : personInCharge.split(';');
        const executionDateMonent = !executionDate ? undefined : moment(executionDate);
        const expiryDateMonent = !expiryDate ? undefined : moment(expiryDate);

        const modalTitle = this.getActionFromMode(mode) + ' General Agreement';
        const isSubmitLoading = submitSaveGeneralAgreementActionStatus === ACTION_STATUS.LOGINING;


        return (
            <div>
                <Modal
                    title={modalTitle}
                    centered
                    width={1000}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetSubmitSaveGeneralAgreementModal()}
                    footer={[
                        <Button key="Cancel" onClick={() => this.props.resetSubmitSaveGeneralAgreementModal() }>
                          Cancel
                        </Button>,
                        <Button key="Submit" type="primary" loading={isSubmitLoading} onClick={() => this.submitSaveGeneralAgreementModal() }>
                          Submit
                        </Button>,
                    ]}
                >
                    <Form layout="horizontal">

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="title">
                                    {getFieldDecorator('title', {
                                        initialValue: title,
                                        rules: [{
                                            required: true,
                                            message: 'Please input title',
                                        }],
                                        })(
                                        <TextArea 
                                            style={{ width: 250, marginLeft: 10 }}
                                            rows={4} 
                                            placeholder='Please input title' 
                                            onChange={(e) => {
                                                this.onInputChange({ name: 'title', value: e.target.value })
                                        }}/>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="personInCharge">
                                    {getFieldDecorator('personInCharge', {
                                        initialValue: personInChargeArray,
                                        rules: [{
                                            required: true,
                                            message: 'Please select personInCharge',
                                        }],
                                        })(
                                        <Select 
                                            allowClear
                                            mode='multiple'
                                            style={{ width: 250, marginLeft: 10 }}
                                            placeholder='Please select personInCharge' 
                                            onChange={(val) => {
                                                this.onPICInputChange(val)
                                        }}>
                                            {userAccountOptions}
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="department">
                                    {getFieldDecorator('department', {
                                        initialValue: department,
                                        rules: [{
                                            required: true,
                                            message: 'Please select department',
                                        }],
                                        })(
                                        <Select
                                            allowClear
                                            style={{ width: 250, marginLeft: 10 }}
                                            onChange={(val) => {
                                                this.onInputChange({ name: 'department', value: val })
                                            }} 
                                            placeholder="Please select department">
                                                {departmentOptions}
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="company">
                                    {getFieldDecorator('company', {
                                        initialValue: company,
                                        rules: [{
                                            required: true,
                                            message: 'Please select company',
                                        }],
                                        })(
                                        <AutoComplete
                                            style={{ width: 250, marginLeft: 10 }}
                                            dataSource={companyOptions}
                                            placeholder='Please select or input company'
                                            onChange={(val) => {
                                                this.onInputChange({ name: 'company', value: val })
                                            }}
                                            filterOption={(inputValue, option) => {
                                                const idx = option.key.toUpperCase().indexOf(inputValue.toUpperCase());
                                                return idx !== -1;
                                            }}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="counterparty">
                                    {getFieldDecorator('counterparty', {
                                        initialValue: counterparty,
                                        rules: [{
                                            required: true,
                                            message: 'Please input counterparty',
                                        }],
                                        })(
                                        <TextArea 
                                            style={{ width: 250, marginLeft: 10 }}
                                            rows={4} 
                                            placeholder='Please input counterparty' 
                                            onChange={(e) => {
                                                this.onInputChange({ name: 'counterparty', value: e.target.value })
                                        }}/>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="executionDate">
                                    {getFieldDecorator('executionDate', {
                                        initialValue:executionDateMonent,
                                        rules: [{
                                            required: true,
                                            message: 'Please select executionDate',
                                        }],
                                        })(
                                        <DatePicker 
                                            allowClear
                                            size='small'
                                            style={{ width: 250, marginLeft: 10 }}
                                            placeholder='executionDate'
                                            onChange={(date, dateString) => {
                                              this.onInputChange({ name: 'executionDate', value: dateString });
                                            }}
                                        />
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="expiryDate">
                                    {getFieldDecorator('expiryDate', {
                                        initialValue: expiryDateMonent,
                                        rules: [{
                                            required: true,
                                            message: 'Please select expiryDate',
                                        }],
                                        })(
                                        <DatePicker 
                                            allowClear
                                            size='small'
                                            style={{ width: 250, marginLeft: 10 }}
                                            placeholder='expiryDate'
                                            onChange={(date, dateString) => {
                                              this.onInputChange({ name: 'expiryDate', value: dateString });
                                            }}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="agreementType">
                                    {getFieldDecorator('agreementType', {
                                        initialValue: agreementType,
                                        rules: [{
                                            required: true,
                                            message: 'Please select or input agreementType',
                                        }],
                                        })(
                                        <AutoComplete
                                            style={{ width: 250, marginLeft: 10 }}
                                            dataSource={agreementTypeOptions}
                                            placeholder='Please select or input agreementType'
                                            onChange={(val) => {
                                                this.onInputChange({ name: 'agreementType', value: val })
                                            }}
                                            filterOption={(inputValue, option) => {
                                                const idx = option.key.toUpperCase().indexOf(inputValue.toUpperCase());
                                                return idx !== -1;
                                            }}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="noticePeriod">
                                    {getFieldDecorator('noticePeriod', {
                                        initialValue: noticePeriod,
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(/^[1-9]$|^[1-9][0-9]$|^[12][0-9][0-9]$|^3(?:[0-5][0-9]|6[0-5])$/, "g"),
                                            message: 'Please input an integer between 1 and 365',
                                        }],
                                        })(
                                        <Input placeholder='Please input noticePeriod' 
                                                style={{ width: 200, marginLeft: 10 }}
                                                onChange={(e) => {
                                                    this.onInputChange({ name: 'noticePeriod', value: e.target.value })
                                            }}
                                        />
                                    )}
                                    <span style={{ marginLeft: 10 }}>days</span>
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="upload">
                                    {getFieldDecorator('uploadOriName', {
                                        initialValue: uploadOriName,
                                        rules: [{
                                            required: true,
                                            message: 'Please upload the Agreement',
                                        }],
                                        })(
                                        <Upload
                                            name="uploadOriName"
                                            withCredentials={true}
                                            multiple={false}
                                            fileList={agreementUploadFileList}
                                            action={generalAgreementUploadUrl}
                                            onChange={this.generalAgreeementHandleChange}
                                        >
                                            <Button style={{ width: 250, marginLeft: 10 }}>
                                                <Icon type="upload" />Upload
                                            </Button>
                                        </Upload>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="terms">
                                    {getFieldDecorator('terms', {
                                        initialValue: terms,
                                        rules: [{
                                            required: true,
                                            message: 'Please input terms',
                                        }],
                                        })(
                                        <TextArea 
                                            style={{ width: 250, marginLeft: 10 }}
                                            rows={3} 
                                            placeholder='Please input terms' 
                                            onChange={(e) => {
                                                this.onInputChange({ name: 'terms', value: e.target.value })
                                        }}/>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="amount">
                                    {getFieldDecorator('amount', {
                                        initialValue: amount,
                                        rules: [{
                                            required: false,
                                            pattern: new RegExp(/^(([0-9]+)|([0-9]+\.[0-9]{1,2}))$/, "g"),
                                            message: 'Please input a positive number with at most two decimal places',
                                        }],
                                        })(
                                            <Input placeholder='Please input amount' 
                                                style={{ width: 250, marginLeft: 10 }}
                                                onChange={(e) => {
                                                    this.onInputChange({ name: 'amount', value: e.target.value })
                                                }}
                                            />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="amountCCY">
                                    {getFieldDecorator('amountCCY', {
                                        initialValue: amountCCY,
                                        rules: [{
                                            required: false,
                                            message: '',
                                        }],
                                        })(
                                            <Select
                                                    allowClear
                                                    style={{ width: 250, marginLeft: 10 }}
                                                    onChange={(val) => {
                                                        this.onInputChange({ name: 'amountCCY', value: val })
                                                    }} 
                                                    placeholder="Please select amountCCY">
                                                {ccyOptions}
                                            </Select>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                        <Col span={12}>
                                <FormItem {...formItemLayout} label="Payer">
                                    {getFieldDecorator('payer', {
                                        initialValue: payer,
                                        rules: [{
                                            required: false,
                                            message: '',
                                        }],
                                        })(
                                            <Input placeholder='Please input Payer' 
                                                style={{ width: 250, marginLeft: 10 }}
                                                onChange={(e) => {
                                                    this.onInputChange({ name: 'payer', value: e.target.value })
                                                }}
                                            />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="remarks">
                                    {getFieldDecorator('remarks', {
                                        initialValue: remarks,
                                        rules: [{
                                            required: false,
                                            message: '',
                                        }],
                                        })(
                                        <TextArea 
                                            style={{ width: 250, marginLeft: 10 }}
                                            rows={4} 
                                            placeholder='Please input remarks' 
                                            onChange={(e) => {
                                                this.onInputChange({ name: 'remarks', value: e.target.value })
                                        }}/>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="comments">
                                    {getFieldDecorator('comments', {
                                        initialValue: comments,
                                        rules: [{
                                            required: false,
                                            message: '',
                                        }],
                                        })(
                                        <TextArea 
                                            style={{ width: 250, marginLeft: 10 }}
                                            rows={4} 
                                            placeholder='Please input comments' 
                                            onChange={(e) => {
                                                this.onInputChange({ name: 'comments', value: e.target.value })
                                        }}/>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                    </Form>
                    {
                        !!respErrMsg &&  
                        <Message negative>
                            <Message.Header>Response Error Message</Message.Header>
                            <p>{ respErrMsg }</p>
                        </Message>
                    }
                </Modal>
            </div>
        );
    }
}

const AddOrEditGeneralAgreementModalDialogForm = Form.create({ name: 'AddOrEditGeneralAgreementModalDialog' })(AddOrEditGeneralAgreementModalDialog);
export default AddOrEditGeneralAgreementModalDialogForm;
